import { createLightTheme, createDarkTheme } from "@fluentui/react-components";
import { priorityOSBrand } from "./brand";

export const lightTheme = createLightTheme(priorityOSBrand);
export const darkTheme = createDarkTheme(priorityOSBrand);
